import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=68bec028&scoped=true&"
import script from "./ItemList.vue?vue&type=script&lang=ts&"
export * from "./ItemList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bec028",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow,VScrollYTransition})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68bec028')) {
      api.createRecord('68bec028', component.options)
    } else {
      api.reload('68bec028', component.options)
    }
    module.hot.accept("./ItemList.vue?vue&type=template&id=68bec028&scoped=true&", function () {
      api.rerender('68bec028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/common/ItemList.vue"
export default component.exports